<div class="parallax_img" id="parallax_img"></div>

<portfolio-navigation></portfolio-navigation>

<main id="main">
    <div class="container coming-soon-container text-center px-md-4">
        <span>BREATHEPODS</span>
        <!-- <p class="mt-4 mb-5 p-0">A learning portfolio. Designed for you. Game-changing.</p> -->
        <!-- <img class="img-fluid" src="../../../../assets/images/backgrounds/coming-soon.jpg"> -->
    </div>
    <section id="module" class="module">
        <div class="pl-5 mt-5">
            <ul class="list-unstyled mt-3 pt-5">
                <li class="category-row" *ngFor="let category of resources">
                    <div class="my-3">
                        <h4 class="text-capitalize" *ngIf="category.resources.length > 0">{{ category.category }}</h4>
                    </div>
                    <ul class="d-flex list-unstyled resources pb-3 overflow-auto">
                        <li class="mr-3" *ngFor="let resource of category.resources">
                            <a (click)="saveResourcePoints(resource.id)">
                                <div class="module-wrap">
                                    <div class="d-flex justify-content-center align-items-center">
                                        <img 
                                            [defaultImage]="preloaderImage"
                                            [lazyLoad]="resource.image_url"
                                            class="module-image"
                                            [id]="'module_image_' + resource.id"
                                            (onStateChange)="moduleImageCallback($event, resource.id)"
                                        >
                                        <div class="d-none description-box" [id]="'description_box_' + resource.id">
                                            {{ resource.title }}
                                        </div>
                                    </div>
                                    <div
                                        class="badge-points d-none py-1 px-2"
                                        [id]="'module_badge_points_' + resource.id"
                                    >
                                        <img class="module-badge-icon" src="../../../../../../assets/images/icons/award.svg">
                                        <span class="d-inline-block align-middle ml-1 ml-md-1 badge-text">{{ resource.points }} points</span>
                                    </div>
                                </div>
                            </a>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>

        <!-- Modal Loader -->
        <modal-loader [modalText]="modalText"></modal-loader>

    </section>
</main>
